import { createRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { Route as pathlessAuthenticatedRoute } from '../../../route';

// Run history moved to Demand forecasting → Run history. The old path still
// resolves, keeping the run a shared link was pointing at.
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/forecast/run-history',
  validateSearch: z.object({ runId: z.uuid().optional() }),
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Inventory }],
      },
    },
  },
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/procurement/demand-forecasting/runs',
      search: search.runId ? { runId: search.runId } : {},
    });
  },
});
